<template>
  <div id="fathead-customizer">
    <div class="customizer customizer-not-found flex-container is-vertical" v-if="!isDataLoaded">
      <navigation-bar />
      <not-found />
    </div><!-- /.customizer-not-found -->

    <div class="customizer flex-container is-vertical" v-else>
      <navigation-bar />

      <design-tab v-if="selectedTab == 0" />

      <summary-tab v-if="selectedTab == 1" />
    </div><!-- /.customizer -->
  </div>
</template>

<script>
import NavigationBar from "@/components/global/NavigationBar"
import DesignTab from "@/views/DesignTab"
import SummaryTab from "@/views/SummaryTab"
import NotFound from "@/views/NotFound"
import { mapState, mapActions } from "vuex"

export default {
  name: "Customizer",
  components: {
    NavigationBar,
    DesignTab,
    SummaryTab,
    NotFound
  },
  mounted() {
    document.body.classList.add('is-sticky');

    const query = (new URLSearchParams(window.location.search.substring(1)));
    const variant_id = query.get('variant');

    let initVariant = null;
    if (this.firstMaterial != null && Object.keys(this.selectedOptions).length === 0) {
      let materialSize = this.materialSizes.find(e => e.name == this.firstMaterial);
      if (materialSize) {
        initVariant = materialSize.variants.find(e => e.id == parseInt(variant_id));
      }
      this.setupSelectedOptions({ allOptionGroups: this.allOptionGroups, initVariant });
    }
  },
  beforeDestroy() {
    document.body.classList.remove('is-sticky');
  },
  computed: {
    ...mapState([
      "selectedTab",
      "selectedOptions",
      "firstMaterial",
      "materialSizes",
      "allOptionGroups",
      "isDataLoaded"
    ])
  },
  methods: {
    ...mapActions(["setupSelectedOptions"])
  }
}
</script>
